import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Container, Body } from '../DefaultStyles/Details';
import { Title, Footer } from '../DefaultStyles/Shared';
import { About, Description } from '../../components/Volunteer/Shared';
import LinkButton from '../../components/Link/LinkButton';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import VolunteerSidebar from '../../components/Volunteer/VolunteerSidebar';
import ShareDrawer from '../../components/ShareDrawer';
import {
    Container as VolunteerContainer,
    PBVMFooter,
    volunteerMatchLogoURL
} from '../../components/Volunteer/Shared';

import { setOverlayPartnerVisible } from '../Widget/actions';
import { onGoToStep } from './actions';

import { isPortrait } from '../../utils/size';
import { isLongText } from '../../components/Shared/commonFunctions';
import { normalizeOpportunityName } from '../../utils/volunteer/helpers';

const SignUpButton = styled(LinkButton)`
    ${() => (isPortrait() ? `margin-bottom: 20px` : ``)};
`;

const PreviewWrapper = styled.div`
    height: 100%;
    width: ${() => (!isPortrait() ? `68%` : `100%`)};
    display: flex;
    flex-direction: column;
    padding-bottom: 6px;
`;

const InnerDescription = styled.span`
    ${() =>
        isPortrait() &&
        `display: block;
        height: 165px;`};
`;

const ReadMore = styled.span`
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
`;

class VolunteerStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDescriptionExpanded: false
        };
    }

    expandableDescription = (description, isExpanded, charLimit) => {
        return isExpanded ? (
            <InnerDescription>{description}</InnerDescription>
        ) : (
            <InnerDescription>
                {description.substring(0, charLimit)}
                {`...`}
                <ReadMore onClick={() => this.setState({ isDescriptionExpanded: true })}>
                    Read More
                </ReadMore>
            </InnerDescription>
        );
    };

    render() {
        return (
            <TransitionContainer
                zIndex={2}
                isSubmitting={this.props.isSubmitting}
                isBackTransition={this.props.isBackTransition}
            >
                <Container>
                    <Overlay />
                    <OverlayPublisher />
                    <OverlayPartner transitionType="right-to-left" />
                    <OverlayPartner
                        logoIsSmall={false}
                        transitionType="right-to-left"
                        logo={volunteerMatchLogoURL}
                        name={'About Volunteer Match'}
                        description={
                            "We believe everyone should have the chance to make a difference. That's why we make it easy for good people and good causes to connect. We've connected millions of people with a great place to volunteer and helped tens of thousands of organizations better leverage volunteers to create real impact."
                        }
                    />
                    <Body>
                        <WidgetHeader />
                        <VolunteerContainer>
                            {!isPortrait() && (
                                <VolunteerSidebar
                                    isPreview={true}
                                    volunteerOpportunity={this.props.volunteerOpportunity}
                                    onChangeOpportunity={() =>
                                        this.props.onGoToStep(0, 0)
                                    }
                                />
                            )}
                            <PreviewWrapper>
                                <Title
                                    scaleFactor={0.85}
                                    isLongText={isLongText(
                                        this.props.volunteerOpportunityTitle,
                                        25
                                    )}
                                    isExtraLongText={isLongText(
                                        this.props.volunteerOpportunityTitle,
                                        60
                                    )}
                                >
                                    {this.props.volunteerOpportunityTitle.length >
                                    (isPortrait() ? 80 : 73)
                                        ? this.props.volunteerOpportunityTitle.substring(
                                              0,
                                              (isPortrait() ? 80 : 73) - 3
                                          ) + '...'
                                        : this.props.volunteerOpportunityTitle}
                                </Title>
                                {isPortrait() && (
                                    <VolunteerSidebar
                                        isPreview={true}
                                        volunteerOpportunity={
                                            this.props.volunteerOpportunity
                                        }
                                        onChangeOpportunity={() =>
                                            this.props.onGoToStep(0, 0)
                                        }
                                    />
                                )}
                                <About>About {this.props.parentOrgName}</About>
                                <Description
                                    isLongDescription={this.props.isLongDescription}
                                    isExpanded={this.state.isDescriptionExpanded}
                                >
                                    {this.props.isLongDescription
                                        ? this.expandableDescription(
                                              this.props.volunteerOpportunityDescription,
                                              this.state.isDescriptionExpanded,
                                              this.props.charLimit
                                          )
                                        : this.props.volunteerOpportunityDescription}
                                </Description>
                                <SignUpButton
                                    height={55}
                                    label={this.props.buttonText}
                                    onClick={() => {
                                        this.props.onGoToStep(1, 2);
                                    }}
                                />
                            </PreviewWrapper>
                        </VolunteerContainer>
                        <Footer>
                            <ShareDrawer
                                hasBackButton={true}
                                goBack={() => this.props.onGoToStep(1, 0)}
                                fullwidth={true}
                                backgroundColor={'#fff'}
                            />
                            <PBVMFooter
                                onClick={e =>
                                    this.props.setOverlayPartnerVisible(true, e, true)
                                }
                            >
                                {'Powered by VolunteerMatch'}
                            </PBVMFooter>
                        </Footer>
                    </Body>
                </Container>
            </TransitionContainer>
        );
    }
}

VolunteerStep1.propTypes = {
    buttonText: PropTypes.string.isRequired,
    charLimit: PropTypes.number.isRequired,
    isBackTransition: PropTypes.bool.isRequired,
    isLongDescription: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    parentOrgName: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    volunteerOpportunity: PropTypes.object.isRequired,
    volunteerOpportunityDescription: PropTypes.string.isRequired,
    volunteerOpportunityTitle: PropTypes.string.isRequired
};

export default connect(
    state => {
        const charLimit = isPortrait() ? 400 : 250;
        return {
            buttonText: 'SIGN UP',
            charLimit,
            isBackTransition: state.volunteer.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            isSubmitting: state.volunteer.isSubmitting,
            isLongDescription:
                state.volunteer.selectedVolunteerOpportunity.description.length >=
                charLimit,
            parentOrgName: state.volunteer.selectedVolunteerOpportunity.parentOrg.name,
            volunteerOpportunity: state.volunteer.selectedVolunteerOpportunity,
            volunteerOpportunityDescription:
                state.volunteer.selectedVolunteerOpportunity.description,
            volunteerOpportunityTitle: normalizeOpportunityName(
                state.volunteer.selectedVolunteerOpportunity.title
            )
        };
    },
    {
        onGoToStep,
        isPortrait,
        setOverlayPartnerVisible
    }
)(VolunteerStep1);
